<template>
    <Header />
    <HeroSlider @scroll-to-why="scrollToWhyArea" />
    <WhyArea />
    <BannerArea />
    <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Inicio/Header.vue';
import HeroSlider from '../components/Inicio/Slider.vue';
import BannerArea from '../components/Inicio/Banners.vue';
import Footer from '../components/Inicio/Footer.vue';
import WhyArea from '../components/Inicio/Sobre.vue';

export default {
    name: 'PaginaInicio',
    components: {
        Header,
        HeroSlider,
        WhyArea,
        BannerArea,
        Footer,
    },
    methods: {
        scrollToWhyArea() {
            const el = document.getElementById('whyarea');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
    },
}
</script>